module.exports = __webpack_public_path__ + "static/media/Marimba.rubber.ff.A5.stereo.8e6636ad.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/stores/audio/Marimba.rubber.ff.A5.stereo.mp3
// module id = 582
// module chunks = 0